import HttpService from "../util/HttpService";
import {TransactionTemplateDto} from "../dto/TransactionTemplateDto";
import {AuthorizeTransactionDto} from "../dto/AuthorizeTransactionDto";
import {ManualReconciliationDto} from "../dto/admin/ManualReconciliationDto";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/cwm/api/v2";
const SERVICE_PATH = "/fund-transaction-service/";

class TransactionService {


    switchInvestMoney = (data: TransactionTemplateDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("switch-money-save"), ParamEncrypt.encryptObject(data));
    }

    saveInvestMoney = (data: TransactionTemplateDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("invest-money-save"), ParamEncrypt.encryptObject(data));
    }

    transferInvestMoney = (data: TransactionTemplateDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("transfer-money-save"), ParamEncrypt.encryptObject(data));
    }
    withdrawMoney = (data: TransactionTemplateDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("withdraw-save"), ParamEncrypt.encryptObject(data));
    }

    authorizeTransactions = (data: AuthorizeTransactionDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("authorize-transaction"), ParamEncrypt.encryptObject(data));
    }
    cancelInvestTransactions = (data: AuthorizeTransactionDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("cancel-invest-request-by-admin"), ParamEncrypt.encryptObject(data));
    }
    retryInvestTransactions = (data: AuthorizeTransactionDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("retry-invest-push-request-by-admin"), ParamEncrypt.encryptObject(data));
    }

    uploadExcelFiles = (data: any) => {
        return HttpService.postWithConfig(CONTEXT_PATH.concat(SERVICE_PATH).concat("upload-invest-detail-excels-from-bank"), data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    manualReconciliation = (data: ManualReconciliationDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("manual-reconcile"), ParamEncrypt.encryptObject(data));
    }

    rejectManualReconciliation = (data: ManualReconciliationDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("manual-reconciliation-reject-by-authorizer"), ParamEncrypt.encryptObject(data));
    }

    authorizeManualReconciliation = (data: ManualReconciliationDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("manual-reconciliation-approve-by-authorizer"), ParamEncrypt.encryptObject(data));
    }
    manualReconcileRejection = (groupNo: number, idList: number[]) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("manual-reconcile-rejection/").concat(ParamEncrypt.encryptData(String(groupNo))), idList);
    }

    previewExcelFiles = (data: any) => {
        return HttpService.postWithConfig(CONTEXT_PATH.concat(SERVICE_PATH).concat("preview-bank-excel"), data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}

const transactionService = new TransactionService();
export default transactionService;